import { AUTH_USER_TYPES } from "../constants/auth.constants";
import {
  AMAZON_CLIENT_ID,
  FLIPKART_CLIENT_ID,
  GMS_CLIENT_ID,
  PANASONIC_CLIENT_ID,
} from "./appConfig";

export const LOGIN_CONTEXTS = [
  {
    id: "system",
    type: AUTH_USER_TYPES.SYSTEM,
    label: "System User",
    tenantId: null,
  },
  {
    id: "panasonic",
    type: AUTH_USER_TYPES.TENANT,
    label: "Panasonic",
    tenantId: "panasonic",
    clientId: PANASONIC_CLIENT_ID,
  },
  {
    id: "flipkart",
    type: AUTH_USER_TYPES.TENANT,
    label: "Flipkart",
    tenantId: "flipkart",
    clientId: FLIPKART_CLIENT_ID,
  },
  {
    id: "amazon",
    type: AUTH_USER_TYPES.TENANT,
    label: "Amazon",
    tenantId: "amazon",
    clientId: AMAZON_CLIENT_ID,
  },
  {
    id: "gms",
    type: AUTH_USER_TYPES.TENANT,
    label: "GMS",
    tenantId: "gms",
    clientId: GMS_CLIENT_ID,
  },
];

export const TENANT_LOGIN_CONTEXTS = LOGIN_CONTEXTS.filter(
  (item) => item.type === AUTH_USER_TYPES.TENANT
);

export const DEFAULT_TENANT_LOGIN_CONTEXT_ID =
  TENANT_LOGIN_CONTEXTS[0]?.id || "panasonic";

export const getLoginContextById = (id) =>
  LOGIN_CONTEXTS.find((item) => item.id === id) || LOGIN_CONTEXTS[0];

const findLoginContextByTenantId = (tenantId) => {
  if (!tenantId) return null;
  const normalized = String(tenantId).toLowerCase();
  return (
    LOGIN_CONTEXTS.find(
      (item) =>
        String(item.tenantId || "").toLowerCase() === normalized ||
        String(item.id || "").toLowerCase() === normalized
    ) || null
  );
};

export const getTenantClientId = (tenantId) =>
  findLoginContextByTenantId(tenantId)?.clientId || null;

export const getTenantLabel = (tenantId) =>
  findLoginContextByTenantId(tenantId)?.label || (tenantId ? String(tenantId) : null);
